@if (theme) {
  <div class="slider-section {{ theme?.root }}">
    <div class="container {{ theme?.container }}">
      @if (sliderTitle) {
        <div
          class="wysiwyg py-v-spacing sm:px-v-spacing max-w-container mx-auto multi-column__title"
          [innerHtml]="sliderTitle"
        ></div>
      }
      <div [class]="containerClasses" class="items-center">
        @if (showAsideContent('right') && asideContent) {
          <div
            class="aside-content-left lg:w-1/2 py-v-spacing sm:px-v-spacing md:mr-v-spacing"
            >
            @if (image && image.url !== null) {
              <span [class.float-left]="containsEyebrow">
                <img
                  [src]="image.url"
                  [alt]="image.altText ? image.altText : ''"
                  class="mr-4 top-slider__seal"
                  width="48"
                  height="48"
                  />
              </span>
            }
            <div class="wysiwyg" [class.flex-eyebrow]="image && image.url !== null" [innerHtml]="asideContent"></div>
          </div>
        }
        <div class="slider {{ carouselClasses }}">
          <div
            #swiperEl
            [class.md:mr-v-spacing]="showAsideContent('left') && asideContent"
            class="swiper h-full"
            >
            <div class="swiper-wrapper">
            @for (slide of sliderSlides; track slide) {
              <div class="swiper-slide">
                @if (slide.slideContent) {
                  <div class="w-full items-center">
                    <div class="wysiwyg py-v-spacing sm:px-v-spacing" [innerHtml]="slide.slideContent"></div>
                  </div>
                }
                @if (
                  !slide.slideContent && slide.slideImage.length > 0 && slide.slideImage[0].url && slide.slideImageLink
                  ) {
                  <a
                    class="w-full h-full contents"
                    [href]="slide.slideImageLink"
                    [attr.target]="slide.slideLinkNewTab ? '_blank' : ''"
              [attr.rel]="
                slide.slideLinkNewTab && slide.slideLinkNofollow
                  ? 'nofollow noopener noreferrer'
                  : slide.slideLinkNewTab && !slide.slideLinkNofollow
                  ? 'noopener noreferrer'
                  : slide.slideLinkNofollow
                  ? 'nofollow'
                  : ''
              "
                    >
                    <img
                      class="slider-full-image carousel-cell-image mx-auto"
                      [src]="imgixService.buildImgixUrl(slide.slideImage[0].url)"
                      [alt]="slide.slideImage[0].altText ? slide.slideImage[0].altText : ''"
                      [height]="slide.slideImage[0].height"
                      [width]="slide.slideImage[0].width"
                    /></a>
                  }
                  @if (
                    !slide.slideContent && slide.slideImage.length > 0 && slide.slideImage[0].url && !slide.slideImageLink
                    ) {
                    <img
                      class="slider-full-image carousel-cell-image mx-auto"
                      [src]="imgixService.buildImgixUrl(slide.slideImage[0].url)"
                      [alt]="slide.slideImage[0].altText ? slide.slideImage[0].altText : ''"
                      [height]="slide.slideImage[0].height"
                      [width]="slide.slideImage[0].width"
                      />
                  }
                </div>
              }
            </div>
          </div>
            <div #paginationEl class="mt-6 flex justify-center"></div>
          </div>
          @if (showAsideContent('left') && asideContent) {
            <div
              class="aside-content-right lg:w-1/2 py-v-spacing sm:px-v-spacing"
              >
              @if (image && image.url !== null) {
                <span [class.float-left]="containsEyebrow">
                  <img
                    [src]="image.url"
                    [alt]="image.altText ? image.altText : ''"
                    class="mr-4 top-slider__seal"
                    width="48"
                    height="48"
                    />
                </span>
              }
              <div class="wysiwyg" [class.flex-eyebrow]="image && image.url !== null" [innerHtml]="asideContent"></div>
            </div>
          }
        </div>
      </div>
    </div>
  }
